export const spacing = (factor: number) => `${factor}rem`;
